// extracted by mini-css-extract-plugin
export default {"product":"y4","image_carousel":"z4","main_gallery":"A4","personalized_badge":"B4","greens_badge":"C4","arrows":"E4","slide":"F4","thumbnail_gallery":"G4","swiper-slide":"H4","learn_more":"I4","product_info":"J4","description_wrapper":"K4","checklist":"L4","checklistItem":"M4","delivery_freq":"N4","tooltip_button":"O4","key_benefits":"P4","benefit_item":"Q4","ingredients":"R4","ingredient_item":"S4","active_slide":"T4","benefits_list":"U4","checkmark":"V4"};
    if(module.hot) {
      // 1721922368481
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  